

















































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ITreeData, IAbp, IPrg, IPpr, IMonthVal, IMonthTotal, ISelected } from "./treeData";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import {log} from "@amcharts/amcharts4/.internal/core/utils/Log";

const monthLst = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

@Component({
    name: 'c-transf-tree-table',
    components: {},
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    }
})
export default class CTransfTreeTable extends AlterationI18nMixin {
    @Prop({
        required: true,
        default: null
    })
    private tableData!: any;

    @Prop({
        required: true,
        default: null
    })
    private accessLevel!: any;

    private collapseAll = true;

    private selectedRow: ISelected | null = null;

    private treeData: ITreeData[] = [];

    private allSum: any = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0 };
    private mounted() {
        this.getTreeData();
        this.$watch('tableData', () => {
            this.getTreeData();
        }, { deep: true });
        this.$watch('locale', () => {
            this.getTreeData();
        }, { deep: true });
    }

    private getTreeData() {
        const treeData: ITreeData[] = [];
        const allSum: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0 };
        if (!this.tableData) {
            this.treeData = [];
            return;
        }
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        this.nameSet(tableData);
        const grArr: any[] = [];
        for (let i = 0; i < tableData.length; i++) {
            const el  = tableData[i];
            if (el.vals && el.vals.length) { el.collapse = this.collapseAll; }
            el._indxArr = i;
        }
        tableData.sort((a: any, b: any) => (a.gr > b.gr) ? 1 : -1);
        for (const el of tableData) {
            if (!grArr.length || grArr[grArr.length-1].gr !== el.gr) {
                grArr.push({ gr: el.gr, grName: el.gr_name,  vals: [el], collapse: this.collapseAll, totalSum: { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0 } });
            } else {
                grArr[grArr.length-1].vals.push(el);
            }
        }
        for (const elGr of grArr) {
            elGr.vals.sort((a: any, b: any) => (a.abp > b.abp) ? 1 : -1);
            const resAbp = this.makeTreeArr(elGr.vals, 'abp');
            for (const elAbp of resAbp) {
                elAbp.vals.sort((a: any, b: any) => (a.prg > b.prg) ? 1 : -1);
                const resPrg = this.makeTreeArr(elAbp.vals, 'prg');
                for (const elPrg of resPrg) {
                    elPrg.vals.sort((a: any, b: any) => (a.ppr > b.ppr) ? 1 : -1);
                    const resPpr = this.makeTreeArr(elPrg.vals, 'ppr');
                    for (const pprEl of resPpr) {
                        pprEl.vals.sort((a: any, b: any) => (a.spf > b.spf) ? 1 : -1);
                        for (const spfEl of pprEl.vals) {
                            if (spfEl.vals && spfEl.vals.length) {
                                // spfEl.collapse = this.collapseAll;
                                for (const child of spfEl.vals) {
                                    if (child.vals && child.vals.length) {
                                        child.collapse = this.collapseAll;
                                    }
                                }
                            }
                        }
                    }
                    elPrg.vals = resPpr;
                }
                elAbp.vals = resPrg;
                this.getSumTotal(allSum, elAbp.totalSum);
                this.getSumTotal(elGr.totalSum, elAbp.totalSum);
            }
            elGr.vals = resAbp;
        }
        this.treeData = grArr;
        this.allSum = allSum;
    }
    private makeTreeArr(arr: any[], fieldName: string) {
        const result: any[] = [];
        const totalSum: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0 };
        for (const el of arr) {
            if (!result.length || result[result.length-1][fieldName] !== el[fieldName]) {
                const obj: any = { vals: [el], collapse: this.collapseAll, totalSum: Object.assign({}, totalSum) };
                this.getSumTotal(obj.totalSum, el);
                obj[fieldName] = el[fieldName];
                if (el[`${fieldName}_name`]) {
                    obj[`${fieldName}Name`] = el[`${fieldName}_name`]
                }
                result.push(obj);
            } else {
                this.getSumTotal(result[result.length-1].totalSum, el);
                result[result.length-1].vals.push(el);
            }
        }
        return result;
    }

    private getSumTotal(total: any, obj: IMonthVal) {
        if (obj.month0) { total.month0 = Math.round(((typeof obj.month0 == 'number' ? obj.month0 : parseFloat(obj.month0)) + total.month0)*10)/10; }
        if (obj.month1) { total.month1 = Math.round(((typeof obj.month1 == 'number' ? obj.month1 : parseFloat(obj.month1)) + total.month1)*10)/10; }
        if (obj.month2) { total.month2 = Math.round(((typeof obj.month2 == 'number' ? obj.month2 : parseFloat(obj.month2)) + total.month2)*10)/10; }
        if (obj.month3) { total.month3 = Math.round(((typeof obj.month3 == 'number' ? obj.month3 : parseFloat(obj.month3)) + total.month3)*10)/10; }
        if (obj.month4) { total.month4 = Math.round(((typeof obj.month4 == 'number' ? obj.month4 : parseFloat(obj.month4)) + total.month4)*10)/10; }
        if (obj.month5) { total.month5 = Math.round(((typeof obj.month5 == 'number' ? obj.month5 : parseFloat(obj.month5)) + total.month5)*10)/10; }
        if (obj.month6) { total.month6 = Math.round(((typeof obj.month6 == 'number' ? obj.month6 : parseFloat(obj.month6)) + total.month6)*10)/10; }
        if (obj.month7) { total.month7 = Math.round(((typeof obj.month7 == 'number' ? obj.month7 : parseFloat(obj.month7)) + total.month7)*10)/10; }
        if (obj.month8) { total.month8 = Math.round(((typeof obj.month8 == 'number' ? obj.month8 : parseFloat(obj.month8)) + total.month8)*10)/10; }
        if (obj.month9) { total.month9 = Math.round(((typeof obj.month9 == 'number' ? obj.month9 : parseFloat(obj.month9)) + total.month9)*10)/10; }
        if (obj.month10) { total.month10 = Math.round(((typeof obj.month10 == 'number' ? obj.month10 : parseFloat(obj.month10)) + total.month10)*10)/10; }
        if (obj.month11) { total.month11 = Math.round(((typeof obj.month11 == 'number' ? obj.month11 : parseFloat(obj.month11)) + total.month11)*10)/10; }
    }

    private clkCollapse(
        grIndx: number | null,
        abpIndx: number | null,
        prgIndx: number | null,
        pprIndx: number | null,
        spfIndx: number | null,
        collapse?: boolean
    ) {
        // Обработка кнопки "Все"
        if (grIndx === null) {
            this.collapseAll = !this.collapseAll;
            this.applyCollapseToAll(this.collapseAll);
            return;
        }

        // Если collapse не передан, выходим
        if (collapse === undefined) return;

        // Получаем текущий элемент на основе индексов
        const element = this.getElementByIndexes(grIndx, abpIndx, prgIndx, pprIndx, spfIndx);
        if (!element) return;

        // Устанавливаем новое состояние collapse для элемента
        if (element.collapse !== undefined) {
            // element.collapse = collapse;
            this.$set(element, 'collapse', collapse);
        }

        // Для родительских элементов применяем collapse ко всем дочерним
        if (spfIndx === null) {
            this.collapseChildren(element, collapse);
        } else {
            this.collapseChildren(element, collapse);
        }
        // Обновляем состояние collapseAll
        this.updateCollapseAllState();
    }

// Вспомогательный метод для получения элемента по индексам
    private getElementByIndexes(
        grIndx: number,
        abpIndx: number | null,
        prgIndx: number | null,
        pprIndx: number | null,
        spfIndx: number | null
    ): any | null {
        if (!this.treeData[grIndx]) return null;
        if (abpIndx === null) return this.treeData[grIndx];

        if (!this.treeData[grIndx].vals[abpIndx]) return null;
        if (prgIndx === null) return this.treeData[grIndx].vals[abpIndx];

        if (!this.treeData[grIndx].vals[abpIndx].vals[prgIndx]) return null;
        if (pprIndx === null) return this.treeData[grIndx].vals[abpIndx].vals[prgIndx];

        if (!this.treeData[grIndx].vals[abpIndx].vals[prgIndx].vals[pprIndx]) return null;
        if (spfIndx === null) return this.treeData[grIndx].vals[abpIndx].vals[prgIndx].vals[pprIndx];

        return this.treeData[grIndx].vals[abpIndx].vals[prgIndx].vals[pprIndx].vals[spfIndx] || null;
    }

// Применяет collapse ко всем дочерним элементам
    private collapseChildren(element: any, collapse: boolean) {
        if (!element.vals) return;

        for (const child of element.vals) {
            if (child.collapse !== undefined) {
                // child.collapse = collapse;
                this.$set(child, 'collapse', collapse);
            }
            this.collapseChildren(child, collapse); // Рекурсивно для вложенных элементов
        }
    }

// Применяет collapse ко всем элементам дерева
    private applyCollapseToAll(collapse: boolean) {
        for (const gr of this.treeData) {
            gr.collapse = collapse;
            this.collapseChildren(gr, collapse);
        }
    }

// Обновляет состояние collapseAll
    private updateCollapseAllState() {
        let allCollapsed = true;
        let allExpanded = true;

        for (const gr of this.treeData) {
            if (!gr.collapse) allCollapsed = false;
            if (gr.collapse) allExpanded = false;

            // Если уже нашли различия, можно прервать проверку
            if (!allCollapsed && !allExpanded) break;
        }

        if (allCollapsed) {
            this.collapseAll = true;
        } else if (allExpanded) {
            this.collapseAll = false;
        }
        // В промежуточных состояниях collapseAll не меняется
    }
    private getLocalizedExpenseName(item: any) {
        const lang = this.$i18n.locale; // или из Vuex/i18n
        const fieldName = `expense_name_${lang}`;
        return item[fieldName] || item.expense_name_ru; // fallback
    }
}
